// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"I1-z","displaySixCardTiles":"J1-z"};